<div class="content-area">
  <div class="clr-row">
    <div class="clr-col-12 align-items-center d-flex">
      <app-back-button [forceShow]="true" [routerLink]="['/activities']"></app-back-button>
      <h1 class="d-inline-block mt-0 ml-3">Patru imagini, un cuvânt din Biblie</h1>
    </div>
    <div class="clr-col-12">
      <iframe src="https://raduanastase.com/fb-api/_extra/4img/"></iframe>
    </div>
  </div>
</div>
